/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Chat_Input_TitleInputs */

const es_walkthrough_chat_input_title = /** @type {(inputs: Walkthrough_Chat_Input_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chateá con Nexy`)
};

const en_walkthrough_chat_input_title = /** @type {(inputs: Walkthrough_Chat_Input_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat with Nexy`)
};

/**
* | output |
* | --- |
* | "Chat with Nexy" |
*
* @param {Walkthrough_Chat_Input_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_chat_input_title = /** @type {((inputs?: Walkthrough_Chat_Input_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Chat_Input_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_chat_input_title(inputs)
	return en_walkthrough_chat_input_title(inputs)
});
export { walkthrough_chat_input_title as "walkthrough.chat_input_title" }